import type { User } from '../types';

/**
 * Panel / korumalı rotalar ile aynı: ücretli plan, aktif bayrak, bitiş tarihi varsa gelecekte.
 */
export function isSubscriptionUiActive(user: User | null | undefined): boolean {
  if (!user) return false;
  if (user.role === 'Admin') return true;
  const hasPaidPlan = user.subscriptionType != null && user.subscriptionType !== 'Free';
  const endOk =
    !user.subscriptionEndDate || new Date(user.subscriptionEndDate) > new Date();
  return !!user.isSubscriptionActive && hasPaidPlan && endOk;
}
